import _ from 'lodash';
import { ALLOWED_FEATURE_KEYS } from './common-constants';

/**
 * NOTE:
 * In some redirection cases, own case is also present.
 * That defines the admin feature required for common post-comment component.
 *
 * All these constants are primarily getting used inside getUserRolePrivilege() of util-common file.
 */

export const ROLE_PRIVILEGE_SPECIAL_CASES = {
  ad: 'advertisement',
  nav: 'navbar'
};

export const ROLE_PRIVILEGE_CHECKING_CASES = [
  ..._.map(ALLOWED_FEATURE_KEYS),
  ..._.map(ROLE_PRIVILEGE_SPECIAL_CASES)
];

export const ALLOWED_SESSION_REDIRECTIONS = [
  'videoStream',
  ALLOWED_FEATURE_KEYS.polls,
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.gamification
];

export const ALLOWED_NOTIFICATION_REDIRECTIONS = [
  'poll',
  ALLOWED_FEATURE_KEYS.news,
  ALLOWED_FEATURE_KEYS.community,
  'session',
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.sponsor,
  'external',
  ALLOWED_FEATURE_KEYS.social,
  ALLOWED_FEATURE_KEYS.attendee
];

export const ALLOWED_SOCIAL_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.social
];

export const ALLOWED_ATTENDEE_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.message,
  ALLOWED_FEATURE_KEYS.meetings
];

export const ALLOWED_SPEAKER_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.message
];

export const ALLOWED_MAPS_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.speaker
];

export const ALLOWED_GALLERY_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.gallery,
  ALLOWED_FEATURE_KEYS.gamification
];

export const ALLOWED_COMMUNITY_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.community
];

export const ALLOWED_MYSCAN_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.exhibitor,
  'scanning',
  'qr'
];

export const ALLOWED_GLOBALSEARCH_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.news,
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.notes
];

export const ALLOWED_NOTES_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.attendee
];

export const ALLOWED_BOOKMARK_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.schedule,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.news,
  ALLOWED_FEATURE_KEYS.attendee
];

export const ALLOWED_ADVERTISEMENT_REDIRECTIONS = [
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.speaker,
  ALLOWED_FEATURE_KEYS.schedule
];

export const NOTREQUIRED_APPTABID_ROUTES = [
  '/overview',
  '/myprofile',
  '/myprofile-exhibitor',
  '/myprofile-sponsor',
  '/myprofile-speaker',
  '/bookmarks',
  '/bookmarks-newsdetails',
  // '/newsdetails',
  '/fourzerofour',
  '/autologin',
  '/sso-auth',
  '/agenda',
  '/notes',
  // '/mapdetails',
  '/notifications',
  '/globalsearch',
  '/myscans',
  '/meetings',
  '/analytics'
];

export const CONDITIONAL_COMMON_FEATURES = [
  ALLOWED_FEATURE_KEYS.notes,
  ALLOWED_FEATURE_KEYS.notifications,
  ALLOWED_FEATURE_KEYS.bookmark,
  ALLOWED_FEATURE_KEYS.agenda
];

export const APPTABID_ROUTE_PATTERN = '/:apptabid?';
